import { useQuery } from '@apollo/client';
import PRACTITIONER_QUALIFICATIONS from 'src/graphql/queries/practitionerQualifications';
import PRACTITIONER_BADGES from 'src/graphql/queries/practitionerBadges';

const useBadgesQualifications = () => {
    const pracId = localStorage.getItem('active_practitioner_id');
    const {
        loading: qualificationsLoading,
        error: qualificationsError,
        data: qualifications,
    } = useQuery(PRACTITIONER_QUALIFICATIONS, { variables: { practitionerId: Number(pracId) } });
    const {
        loading: badgesLoading,
        error: badgesError,
        data: badges,
    } = useQuery(PRACTITIONER_BADGES, { variables: { practitionerId: Number(pracId) } });

    return {
        qualifications,
        qualificationsLoading,
        qualificationsError,
        badges,
        badgesLoading,
        badgesError,
    };
};

export default useBadgesQualifications;